export class PropertyValue {
    public __classname__: string = 'PropertyValue';

    public Value : string;
	public Display : string | null;
	public Entity : string | null;
    constructor(params : PropertyValueNamedParameters) {
        this.Value = params.Value;
        this.Display = params.Display ?? null;
        this.Entity = params.Entity ?? null;
    }  
}
export interface PropertyValueNamedParameters {
    Value: string,
    Display?: string,
    Entity?: string
}